import React, { useEffect, useState, useCallback } from 'react';
import { Card, Table, Tag, Button, notification, Typography, Space } from 'antd';
import {
  ArrowLeftOutlined, ApiOutlined, PaperClipOutlined,
} from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { mailApi, SubscriptionItem } from '../api/mail';

const { Title } = Typography;

const MailSubscriptionsPage: React.FC = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState<SubscriptionItem[]>([]);
  const [loading, setLoading] = useState(false);

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await mailApi.getSubscriptions();
      setItems(data.items);
    } catch {
      notification.error({ message: 'Ошибка загрузки подписок' });
    }
    setLoading(false);
  }, []);

  useEffect(() => { fetch(); }, [fetch]);

  const columns: ColumnsType<SubscriptionItem> = [
    {
      title: 'Модуль',
      dataIndex: 'module_name',
      width: 140,
    },
    {
      title: 'Обработчик',
      dataIndex: 'handler_name',
      width: 180,
      render: (v: string) => <code>{v}</code>,
    },
    {
      title: 'Фильтр отправителя',
      dataIndex: 'sender_filter',
      ellipsis: true,
      render: (v: string | null) => v || <span style={{ color: '#999' }}>любой</span>,
    },
    {
      title: 'Фильтр темы',
      dataIndex: 'subject_filter',
      ellipsis: true,
      render: (v: string | null) => v || <span style={{ color: '#999' }}>любая</span>,
    },
    {
      title: '',
      dataIndex: 'require_attachment',
      width: 40,
      align: 'center',
      render: (v: boolean) => v ? <PaperClipOutlined title="Требуется вложение" /> : null,
    },
    {
      title: 'Приоритет',
      dataIndex: 'priority',
      width: 90,
      align: 'center',
    },
    {
      title: 'Статус',
      dataIndex: 'is_active',
      width: 100,
      render: (v: boolean) => (
        <Tag color={v ? 'green' : 'default'}>{v ? 'Активна' : 'Выкл'}</Tag>
      ),
    },
    {
      title: 'Последнее срабатывание',
      dataIndex: 'last_triggered_at',
      width: 170,
      render: (v: string | null) => v ? dayjs(v).format('DD.MM.YY HH:mm') : '-',
    },
  ];

  return (
    <Card>
      <Space style={{ marginBottom: 16 }} align="center">
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/mail')}
        >
          Почта
        </Button>
        <Title level={4} style={{ margin: 0 }}>
          <ApiOutlined /> Подписки на почтовый сервис
        </Title>
      </Space>
      <Table
        dataSource={items}
        columns={columns}
        rowKey="id"
        loading={loading}
        size="small"
        pagination={false}
      />
    </Card>
  );
};

export default MailSubscriptionsPage;
